import * as React from "react";

import { connect } from "react-redux";

import { changePage } from "../actions";
import { Page, Pages } from "../Page";
import { RootState } from "../types";
import { Nav } from "./Nav";

import "bootstrap/dist/js/bootstrap";

interface IProps {
  currentPage: Page;
  onNavigate: (selected: Page) => void;
}

function renderPage(page: Page): React.ReactNode {
  const Component = Pages[page].component;
  return <Component />;
}

export const Router: React.SFC<IProps> = ({ currentPage, onNavigate }) => (
  <div className="router">
    <Nav onClick={onNavigate} currentPage={currentPage} />
    {renderPage(currentPage)}
  </div>
);

export const RouterContainer = connect(
  ({ page }: RootState) => ({ currentPage: page }),
  dispatch => ({
    onNavigate: (selected: Page) => {
      dispatch(changePage(selected));
    },
  })
)(Router);

export default RouterContainer;



// WEBPACK FOOTER //
// ./src/components/Router.tsx